
const timeMachine = {
    millisecondsToDaysHoursMinutes(t: number) {
        var cd = 24 * 60 * 60 * 1000,
            ch = 60 * 60 * 1000,
            d = Math.floor(t / cd),
            h = Math.floor((t - d * cd) / ch),
            m = Math.round((t - d * cd - h * ch) / 60000),
            pad = function (n: string | number) { return n < 10 ? "0" + n : n }
        if (m === 60) {
            h++
            m = 0
        }
        if (h === 24) {
            d++
            h = 0
        }
        return [d, pad(h), pad(m)].join(":")
    }
}

export default timeMachine